export default {"src":"/_next/static/media/sushi.0f8ed58e.svg","height":24,"width":24};